import { useMemo } from 'react';
import useBasket from '../basket/useBasket';
import useOrderFlow from './useOrderFlow';

export default function useCheckoutThreshold() {
  const { data } = useOrderFlow();
  const { total: basketTotal } = useBasket();

  const total = data?.total ?? basketTotal;

  const hasReachedCheckoutThreshold = useMemo(() => total === 0 || total >= 1, [total]);

  return {
    hasReachedCheckoutThreshold,
  };
}
